import ColorScaleService from '@/services/ColorScale.service';
import Tone from '@/models/tone';

export default class Scale {
    public baseHue: number;
    public mode: number;
    public chromaticScale: Tone[][];
    public modalScale: any;
    public fifthsCircle: any;
    public cromaticScaleNames: any;
    public modeTones!: number[];
    public modalScaleNames: any;
    public amplitude: any;
    
    constructor(baseHue: number, mode: number){
      //Sumem 19.06 per a que coincideixi el 0 amb HSB.
      //colorMode(RGB,255,255,255);
      this.baseHue = baseHue;
      this.mode = mode;
      this.chromaticScale = ColorScaleService.getChromaticScale(baseHue);
      this.modalScale = ColorScaleService.getModalScale(this.chromaticScale, this.mode);
      this.modeTones = ColorScaleService.getModeTones(this.mode);
      //this.cromaticScaleNames = getCromaticScaleNames();
      //this.modalScaleNames = getModalScaleNames();
    }
}